import { useEffect } from 'react';
import type { StepProps } from '../engine/context.ts';
import { Icon } from '../ui/Icon.tsx';
import { CREAM, MUTED, ORANGE } from '../ui/theme.ts';
import { Ring } from '../ui/bits.tsx';

/**
 * Shown between the CTA press and the overlay opening — at least 300 ms so it
 * never flashes, and at most 4 s before falling back to the plan page.
 */
export function CheckoutHandoff({ ctx }: StepProps) {
  const shared = ctx.shared.checkout;

  useEffect(() => {
    ctx.setCta({ label: null });
    const t = setTimeout(() => ctx.back(), 4000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18, textAlign: 'center', minHeight: 420 }}>
      <Ring size={72} inner={58} background={CREAM} />
      <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-.02em' }}>{shared.title}</div>
      <div style={{ fontSize: 13, color: MUTED, fontWeight: 600, display: 'inline-flex', gap: 6, alignItems: 'center' }}>
        <Icon name="lock-key" size={16} color={ORANGE} />
        {shared.sub}
      </div>
    </div>
  );
}
